import type {TextAlign} from './textTypes'

/** Available 3D typeface fonts (generated by scripts/convert-fonts.mjs) */
export const FONT_3D_OPTIONS = [
  {
    label: 'Roboto',
    regular: '/fonts/3d/roboto/roboto-v51-regular.typeface.json',
    italic: '/fonts/3d/roboto/roboto-v51-italic.typeface.json',
    '500': '/fonts/3d/roboto/roboto-v51-500.typeface.json',
    '500italic': '/fonts/3d/roboto/roboto-v51-500italic.typeface.json',
  },
  {
    label: 'Open Sans',
    regular: '/fonts/3d/open-sans/open-sans-v44-regular.typeface.json',
    italic: '/fonts/3d/open-sans/open-sans-v44-italic.typeface.json',
    '500': '/fonts/3d/open-sans/open-sans-v44-500.typeface.json',
    '500italic': '/fonts/3d/open-sans/open-sans-v44-500italic.typeface.json',
  },
  {
    label: 'Google Sans',
    regular: '/fonts/3d/google-sans/google-sans-v67-regular.typeface.json',
    italic: '/fonts/3d/google-sans/google-sans-v67-italic.typeface.json',
    '500': '/fonts/3d/google-sans/google-sans-v67-500.typeface.json',
    '500italic': '/fonts/3d/google-sans/google-sans-v67-500italic.typeface.json',
  },
  {
    label: 'Inter',
    regular: '/fonts/3d/inter/inter-v20-regular.typeface.json',
    italic: '/fonts/3d/inter/inter-v20-italic.typeface.json',
    '500': '/fonts/3d/inter/inter-v20-500.typeface.json',
    '500italic': '/fonts/3d/inter/inter-v20-500italic.typeface.json',
  },
  {
    label: 'Roboto Condensed',
    regular: '/fonts/3d/roboto-condensed/roboto-condensed-v31-regular.typeface.json',
    italic: '/fonts/3d/roboto-condensed/roboto-condensed-v31-italic.typeface.json',
    '500': '/fonts/3d/roboto-condensed/roboto-condensed-v31-500.typeface.json',
    '500italic': '/fonts/3d/roboto-condensed/roboto-condensed-v31-500italic.typeface.json',
  },
  {
    label: 'Arimo',
    regular: '/fonts/3d/arimo/arimo-v35-regular.typeface.json',
    italic: '/fonts/3d/arimo/arimo-v35-italic.typeface.json',
    '500': '/fonts/3d/arimo/arimo-v35-500.typeface.json',
    '500italic': '/fonts/3d/arimo/arimo-v35-500italic.typeface.json',
  },
  {
    label: 'Noto Sans',
    regular: '/fonts/3d/noto-sans/noto-sans-v42-regular.typeface.json',
    italic: '/fonts/3d/noto-sans/noto-sans-v42-italic.typeface.json',
    '500': '/fonts/3d/noto-sans/noto-sans-v42-500.typeface.json',
    '500italic': '/fonts/3d/noto-sans/noto-sans-v42-500italic.typeface.json',
  },
  {
    label: 'Ubuntu',
    regular: '/fonts/3d/ubuntu/ubuntu-v21-regular.typeface.json',
    italic: '/fonts/3d/ubuntu/ubuntu-v21-italic.typeface.json',
    '500': '/fonts/3d/ubuntu/ubuntu-v21-500.typeface.json',
    '500italic': '/fonts/3d/ubuntu/ubuntu-v21-500italic.typeface.json',
  },
  {
    label: 'Fira Sans',
    regular: '/fonts/3d/fira-sans/fira-sans-v18-regular.typeface.json',
    italic: '/fonts/3d/fira-sans/fira-sans-v18-italic.typeface.json',
    '500': '/fonts/3d/fira-sans/fira-sans-v18-500.typeface.json',
    '500italic': '/fonts/3d/fira-sans/fira-sans-v18-500italic.typeface.json',
  },
  {
    label: 'Noto Serif',
    regular: '/fonts/3d/noto-serif/noto-serif-v33-regular.typeface.json',
    italic: '/fonts/3d/noto-serif/noto-serif-v33-italic.typeface.json',
    '500': '/fonts/3d/noto-serif/noto-serif-v33-500.typeface.json',
    '500italic': '/fonts/3d/noto-serif/noto-serif-v33-500italic.typeface.json',
  },
  {
    label: 'Source Sans 3',
    regular: '/fonts/3d/source-sans-3/source-sans-3-v19-regular.typeface.json',
    italic: '/fonts/3d/source-sans-3/source-sans-3-v19-italic.typeface.json',
    '500': '/fonts/3d/source-sans-3/source-sans-3-v19-500.typeface.json',
    '500italic': '/fonts/3d/source-sans-3/source-sans-3-v19-500italic.typeface.json',
  },
  {
    label: 'Source Code Pro',
    regular: '/fonts/3d/source-code-pro/source-code-pro-v31-regular.typeface.json',
    italic: '/fonts/3d/source-code-pro/source-code-pro-v31-italic.typeface.json',
    '500': '/fonts/3d/source-code-pro/source-code-pro-v31-500.typeface.json',
    '500italic': '/fonts/3d/source-code-pro/source-code-pro-v31-500italic.typeface.json',
  },
  {
    label: 'EB Garamond',
    regular: '/fonts/3d/eb-garamond/eb-garamond-v32-regular.typeface.json',
    italic: '/fonts/3d/eb-garamond/eb-garamond-v32-italic.typeface.json',
    '500': '/fonts/3d/eb-garamond/eb-garamond-v32-500.typeface.json',
    '500italic': '/fonts/3d/eb-garamond/eb-garamond-v32-500italic.typeface.json',
  },
  {
    label: 'Inter Tight',
    regular: '/fonts/3d/inter-tight/inter-tight-v9-regular.typeface.json',
    italic: '/fonts/3d/inter-tight/inter-tight-v9-italic.typeface.json',
    '500': '/fonts/3d/inter-tight/inter-tight-v9-500.typeface.json',
    '500italic': '/fonts/3d/inter-tight/inter-tight-v9-500italic.typeface.json',
  },
  {
    label: 'Fira Sans Condensed',
    regular: '/fonts/3d/fira-sans-condensed/fira-sans-condensed-v11-regular.typeface.json',
    italic: '/fonts/3d/fira-sans-condensed/fira-sans-condensed-v11-italic.typeface.json',
    '500': '/fonts/3d/fira-sans-condensed/fira-sans-condensed-v11-500.typeface.json',
    '500italic': '/fonts/3d/fira-sans-condensed/fira-sans-condensed-v11-500italic.typeface.json',
  },
  {
    label: 'Alegreya',
    regular: '/fonts/3d/alegreya/alegreya-v39-regular.typeface.json',
    italic: '/fonts/3d/alegreya/alegreya-v39-italic.typeface.json',
    '500': '/fonts/3d/alegreya/alegreya-v39-500.typeface.json',
    '500italic': '/fonts/3d/alegreya/alegreya-v39-500italic.typeface.json',
  },
  {
    label: 'Alegreya Sans',
    regular: '/fonts/3d/alegreya-sans/alegreya-sans-v26-regular.typeface.json',
    italic: '/fonts/3d/alegreya-sans/alegreya-sans-v26-italic.typeface.json',
    '500': '/fonts/3d/alegreya-sans/alegreya-sans-v26-500.typeface.json',
    '500italic': '/fonts/3d/alegreya-sans/alegreya-sans-v26-500italic.typeface.json',
  },
  {
    label: 'Literata',
    regular: '/fonts/3d/literata/literata-v40-regular.typeface.json',
    italic: '/fonts/3d/literata/literata-v40-italic.typeface.json',
    '500': '/fonts/3d/literata/literata-v40-500.typeface.json',
    '500italic': '/fonts/3d/literata/literata-v40-500italic.typeface.json',
  },
  {
    label: 'Noto Sans Display',
    regular: '/fonts/3d/noto-sans-display/noto-sans-display-v30-regular.typeface.json',
    italic: '/fonts/3d/noto-sans-display/noto-sans-display-v30-italic.typeface.json',
    '500': '/fonts/3d/noto-sans-display/noto-sans-display-v30-500.typeface.json',
    '500italic': '/fonts/3d/noto-sans-display/noto-sans-display-v30-500italic.typeface.json',
  },
  {
    label: 'Noto Serif Display',
    regular: '/fonts/3d/noto-serif-display/noto-serif-display-v29-regular.typeface.json',
    italic: '/fonts/3d/noto-serif-display/noto-serif-display-v29-italic.typeface.json',
    '500': '/fonts/3d/noto-serif-display/noto-serif-display-v29-500.typeface.json',
    '500italic': '/fonts/3d/noto-serif-display/noto-serif-display-v29-500italic.typeface.json',
  },
  {
    label: 'Fira Sans Extra Condensed',
    regular: '/fonts/3d/fira-sans-extra-condensed/fira-sans-extra-condensed-v11-regular.typeface.json',
    italic: '/fonts/3d/fira-sans-extra-condensed/fira-sans-extra-condensed-v11-italic.typeface.json',
    '500': '/fonts/3d/fira-sans-extra-condensed/fira-sans-extra-condensed-v11-500.typeface.json',
    '500italic': '/fonts/3d/fira-sans-extra-condensed/fira-sans-extra-condensed-v11-500italic.typeface.json',
  },
  {
    label: 'Alegreya Sans SC',
    regular: '/fonts/3d/alegreya-sans-sc/alegreya-sans-sc-v24-regular.typeface.json',
    italic: '/fonts/3d/alegreya-sans-sc/alegreya-sans-sc-v24-italic.typeface.json',
    '500': '/fonts/3d/alegreya-sans-sc/alegreya-sans-sc-v24-500.typeface.json',
    '500italic': '/fonts/3d/alegreya-sans-sc/alegreya-sans-sc-v24-500italic.typeface.json',
  },
  {
    label: 'Ubuntu Sans',
    regular: '/fonts/3d/ubuntu-sans/ubuntu-sans-v4-regular.typeface.json',
    italic: '/fonts/3d/ubuntu-sans/ubuntu-sans-v4-italic.typeface.json',
    '500': '/fonts/3d/ubuntu-sans/ubuntu-sans-v4-500.typeface.json',
    '500italic': '/fonts/3d/ubuntu-sans/ubuntu-sans-v4-500italic.typeface.json',
  },
  {
    label: 'Alegreya SC',
    regular: '/fonts/3d/alegreya-sc/alegreya-sc-v26-regular.typeface.json',
    italic: '/fonts/3d/alegreya-sc/alegreya-sc-v26-italic.typeface.json',
    '500': '/fonts/3d/alegreya-sc/alegreya-sc-v26-500.typeface.json',
    '500italic': '/fonts/3d/alegreya-sc/alegreya-sc-v26-500italic.typeface.json',
  },
  {
    label: 'Piazzolla',
    regular: '/fonts/3d/piazzolla/piazzolla-v40-regular.typeface.json',
    italic: '/fonts/3d/piazzolla/piazzolla-v40-italic.typeface.json',
    '500': '/fonts/3d/piazzolla/piazzolla-v40-500.typeface.json',
    '500italic': '/fonts/3d/piazzolla/piazzolla-v40-500italic.typeface.json',
  },
  {
    label: 'Iosevka Charon',
    regular: '/fonts/3d/iosevka-charon/iosevka-charon-v1-regular.typeface.json',
    italic: '/fonts/3d/iosevka-charon/iosevka-charon-v1-italic.typeface.json',
    '500': '/fonts/3d/iosevka-charon/iosevka-charon-v1-500.typeface.json',
    '500italic': '/fonts/3d/iosevka-charon/iosevka-charon-v1-500italic.typeface.json',
  },
  {
    label: 'Ubuntu Sans Mono',
    regular: '/fonts/3d/ubuntu-sans-mono/ubuntu-sans-mono-v3-regular.typeface.json',
    italic: '/fonts/3d/ubuntu-sans-mono/ubuntu-sans-mono-v3-italic.typeface.json',
    '500': '/fonts/3d/ubuntu-sans-mono/ubuntu-sans-mono-v3-500.typeface.json',
    '500italic': '/fonts/3d/ubuntu-sans-mono/ubuntu-sans-mono-v3-500italic.typeface.json',
  },
  {
    label: 'Iosevka Charon Mono',
    regular: '/fonts/3d/iosevka-charon-mono/iosevka-charon-mono-v1-regular.typeface.json',
    italic: '/fonts/3d/iosevka-charon-mono/iosevka-charon-mono-v1-italic.typeface.json',
    '500': '/fonts/3d/iosevka-charon-mono/iosevka-charon-mono-v1-500.typeface.json',
    '500italic': '/fonts/3d/iosevka-charon-mono/iosevka-charon-mono-v1-500italic.typeface.json',
  },
  // CJK fonts have no true italic — italic variants alias the upright files
  {
    label: 'Noto Sans JP',
    regular: '/fonts/3d/noto-sans-jp/noto-sans-jp-v56-regular.typeface.json',
    italic: '/fonts/3d/noto-sans-jp/noto-sans-jp-v56-regular.typeface.json',
    '500': '/fonts/3d/noto-sans-jp/noto-sans-jp-v56-500.typeface.json',
    '500italic': '/fonts/3d/noto-sans-jp/noto-sans-jp-v56-500.typeface.json',
  },
  {
    label: 'Noto Sans KR',
    regular: '/fonts/3d/noto-sans-kr/noto-sans-kr-v39-regular.typeface.json',
    italic: '/fonts/3d/noto-sans-kr/noto-sans-kr-v39-regular.typeface.json',
    '500': '/fonts/3d/noto-sans-kr/noto-sans-kr-v39-500.typeface.json',
    '500italic': '/fonts/3d/noto-sans-kr/noto-sans-kr-v39-500.typeface.json',
  },
  {
    label: 'Noto Sans SC',
    regular: '/fonts/3d/noto-sans-sc/noto-sans-sc-v40-regular.typeface.json',
    italic: '/fonts/3d/noto-sans-sc/noto-sans-sc-v40-regular.typeface.json',
    '500': '/fonts/3d/noto-sans-sc/noto-sans-sc-v40-500.typeface.json',
    '500italic': '/fonts/3d/noto-sans-sc/noto-sans-sc-v40-500.typeface.json',
  },
] as const

export type Font3DLabel = (typeof FONT_3D_OPTIONS)[number]['label']

/** Material properties for 3D text */
export interface Text3DMaterial {
  metalness: number
  roughness: number
  clearcoat: number
  clearcoatRoughness: number
  reflectivity: number
}

export interface SceneText3D {
  id: string
  text: string
  fontFamily: Font3DLabel
  /** Font size in world units */
  fontSize: number
  /** Extrusion depth in world units */
  depth: number
  color: string
  bold: boolean
  italic: boolean
  /** Intra-block line alignment; the block stays centered at (x,y,z).
   *  Optional — configs saved before the field existed fall back to 'center'. */
  align?: TextAlign
  /** When true the text renders unlit (MeshBasicMaterial) AND drops out of the
   *  shadow render entirely (no cast, no receive). When false the text uses a
   *  full PBR material and participates in shadows. */
  unlit: boolean
  /** PBR material properties — used only when unlit is false */
  material: Text3DMaterial
  /** World-space X position */
  x: number
  /** World-space Y position */
  y: number
  /** World-space Z position */
  z: number
  /** Rotation around X axis in degrees */
  rotationX: number
  /** Rotation around Y axis in degrees */
  rotationY: number
  /** Rotation around Z axis in degrees */
  rotationZ: number
}

// IDs use `crypto.randomUUID()` — see comment in spriteTypes.ts for the rationale
// (module-level counter collides with saved IDs after a fresh page load).
export const generateText3dId = (): string => `text3d-${crypto.randomUUID()}`

/** Resolve the font URL based on family + bold + italic */
export const resolveFontUrl = (family: Font3DLabel, bold: boolean, italic: boolean): string => {
  const entry = FONT_3D_OPTIONS.find((f) => f.label === family) ?? FONT_3D_OPTIONS[0]
  if (bold && italic) return entry['500italic']
  if (bold) return entry['500']
  if (italic) return entry.italic
  return entry.regular
}

/** Whether the family has a true italic variant (CJK fonts alias italic to the upright file) */
export const fontHasItalic = (family: Font3DLabel): boolean => {
  const entry = FONT_3D_OPTIONS.find((f) => f.label === family) ?? FONT_3D_OPTIONS[0]
  return entry.italic !== entry.regular
}

/** Default material for new 3D text */
const DEFAULT_MATERIAL: Text3DMaterial = {
  metalness: 0.0,
  roughness: 0.4,
  clearcoat: 0.0,
  clearcoatRoughness: 0.1,
  reflectivity: 0.5,
}

/** Create a new 3D text with sensible defaults */
export const createSceneText3D = (text: string = 'Your Text'): SceneText3D => ({
  id: generateText3dId(),
  text,
  fontFamily: 'Roboto',
  fontSize: 12,
  depth: 3,
  color: '#ffffff',
  bold: true,
  italic: false,
  align: 'center',
  unlit: false,
  material: {...DEFAULT_MATERIAL},
  x: 0,
  y: 90,
  z: 0,
  rotationX: 0,
  rotationY: 0,
  rotationZ: 0,
})
